(function(app) {
    app.provider("enrollmentApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    //GETs
                    service.getClientEnrollment = function(enrollmentId) {
                        return crmApiGateway.get("/ClientEnrollments/" + enrollmentId);
                    };

                    service.getPipelineEnrollments = function(pipelineId) {
                        return crmApiGateway.getArray("/SalesPipelines/" + pipelineId + "/ClientEnrollments");
                    };

                    //PUTs
                    service.updateClientEnrollment = function(enrollmentId, enrollment) {
                        return crmApiGateway.put("/ClientEnrollments/" + enrollment.Id, enrollment);
                    };

                    //POSTs
                    service.addClientEnrollment = function(pipelineId, enrollment) {
                        return crmApiGateway.post("/ClientEnrollments", enrollment);
                    };

                    //DELETEs
                    service.delete = function(enrollmentId) {
                        return crmApiGateway.delete("/ClientEnrollments/" + enrollmentId);
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line